<template>
  <div class="workOrders">
    <div class="signContent">
      <div
        class="signCard"
      >
        <div class="signTitle">故障原因</div>
        <van-field
          class="textarea-box"
          v-model="dataForm.carStatus"
          maxlength="20"
          name="pattern"
          placeholder="请填写故障原因"
          @blur="saveCarStatus"
        />
      </div>
      <div
        class="signCard"
        v-if="!hiddenCustomerSign"
      >
        <div class="signTitle">顾客签字</div>
        <div
          class="sign"
          @click="goCustomerSign"
        >
          <div
            class="signature__pad"
            v-if="!customerSignPath"
          >
            <img
              src="@/assets/img/orderGeneral/order_icon_edit@2x.png"
              class="signIcon"
            >
            点击顾客签字
          </div>
          <img
            class="signature__img"
            v-else
            :src="customerSignPath"
          >
        </div>
      </div>
      <div class="signCard">
        <div class="signTitle">救援师傅签字</div>
        <div
          class="sign"
          @click="goOperatorSign"
        >
          <div
            class="signature__pad"
            v-if="!operatorSignPath"
          >
            <img
              src="@/assets/img/orderGeneral/order_icon_edit@2x.png"
              class="signIcon"
            >
            点击救援师傅签字
          </div>
          <img
            class="signature__img"
            v-else
            :src="operatorSignPath"
          >
        </div>
      </div>
      <!-- 长城拖车订单必填 取消订单不需要（有费无费放空救援失败都算取消） -->
      <div
        class="signCard"
        v-if="!hiddenPickUpPersonSign && isTrailer && isCCQC"
      >
        <div class="signTitle">接车人签字</div>
        <div
          class="sign"
          @click="goPickUpPersonSign"
        >
          <div
            class="signature__pad"
            v-if="!pickUpPersonSignPath"
          >
            <img
              src="@/assets/img/orderGeneral/order_icon_edit@2x.png"
              class="signIcon"
            >
            点击接车人签字
          </div>
          <img
            class="signature__img"
            v-else
            :src="pickUpPersonSignPath"
          >
        </div>
      </div>
    </div>
    <!-- 确认弹窗 -->
    <ConfirmDialog
      ref="confirmDialog"
    />
  </div>
</template>

<script>
import { getTaskDetail, saveRescueReport, getRescueReport } from '@/common/apiPaic.js';
import { generalProductCode } from '@/common/constant.js';
import jsApi from '@/common/jsApi';
import dayjs from 'dayjs';
import ConfirmDialog from '@/components/confirmDialog.vue';
export default {
  name: 'WorkOrders',
  components: {
    ConfirmDialog
  },
  props: {
    orderNo: {
      type: String,
      required: true
    },
    taskNo: {
      type: String,
      required: true
    },
    hiddenCustomerSign: {
      type: Boolean,
      default: false
    },
    hiddenPickUpPersonSign: {
      type: Boolean,
      default: false
    },
    useIncomingIsBlackScreens: {
      type: Boolean,
      default: false
    },
    isBlackScreens: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      taskDetail: {},
      formList: [
        {
          key: 'categoryCodeName',
          value: '业务类型'
        },
        {
          key: 'payType',
          value: '收费类型'
        },
        {
          key: 'contactName',
          value: '客户名称'
        },
        {
          key: 'orderNo',
          value: '订单编号'
        },
        {
          key: 'carNo',
          value: '车牌号'
        },
        {
          key: 'vinNo',
          value: '车架号'
        },
        {
          key: 'modelName',
          value: '车型'
        },
        {
          key: 'createTime',
          value: '救援日期'
        },
        {
          key: 'arriveMileageInfo',
          value: '救援车辆从出发地到救援地里程（KM）'
        },
        {
          key: 'appealDistanceInfo',
          value: '救援车辆从救援地到目的地里程（KM）'
        },
        {
          key: 'contactAddress',
          value: '救援地'
        },
        {
          key: 'destination',
          value: '目的地'
        },
        {
          key: 'extraProductInfo',
          value: '增值产品'
        }
      ],
      formData: {},
      checkList: ['白天', '夜间', '非雨雪天', '雨雪天', '干净', '脏'],
      dataForm: {
        rescueEnvironment: [],
        carStatus: ''
      },
      customerSignPath: '',
      operatorSignPath: '',
      pickUpPersonSignPath: '',
      isH5: true,
      isFirst: true
    };
  },
  computed: {
    isCCQC() {
      // 长城汽车
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'CCQC';
    },
    // 拖车
    isTrailer() {
      return this.taskDetail && [generalProductCode.categoryCode_FL10000002, generalProductCode.categoryCode_FL90000002].includes(this.taskDetail.categoryCode);
    },
    // 安盛天平
    isTPBX() {
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'TPBX';
    },
    // 华安
    isHAIC() {
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'HAIC';
    }
  },
  watch: {
    isBlackScreens: {
      handler(val) {
        if (this.useIncomingIsBlackScreens) {
          if (val) {
            this.setCarStatus('故障状态无法复现，确需拖车服务');
            this.saveCarStatus();
          } else {
            this.setCarStatus('');
            this.saveCarStatus();
          }
        }
      },
      immediate: true
    }
  },
  created() {
    localStorage.removeItem('customerSignPath');
    localStorage.removeItem('customerSignPicId');
    localStorage.removeItem('operatorSignPath');
    localStorage.removeItem('operatorSignPicId');
    localStorage.removeItem('pickUpPersonSignPath');
    localStorage.removeItem('pickUpPersonSignPicId');
    this.getRescueReport();
  },
  activated() {
    if (localStorage.getItem('isSign') === '0') {
      this.getRescueReport();
    }
    const customerSignPath = localStorage.getItem('customerSignPath') || '';
    const customerSignPicId = localStorage.getItem('customerSignPicId') || '';
    if (customerSignPath) {
      this.dataForm.customerSign = customerSignPicId; // 保存用id
      this.customerSignPath = customerSignPath;
      localStorage.removeItem('customerSignPath');
      localStorage.removeItem('customerSignPicId');
    }
    const operatorSignPath = localStorage.getItem('operatorSignPath') || '';
    const operatorSignPicId = localStorage.getItem('operatorSignPicId') || '';
    if (operatorSignPath) {
      this.dataForm.operatorSign = operatorSignPicId; // 保存用id
      this.operatorSignPath = operatorSignPath;
      localStorage.removeItem('operatorSignPath');
      localStorage.removeItem('operatorSignPicId');
    }
    const pickUpPersonSignPath = localStorage.getItem('pickUpPersonSignPath') || '';
    const pickUpPersonSignPicId = localStorage.getItem('pickUpPersonSignPicId') || '';
    if (pickUpPersonSignPath) {
      this.dataForm.pickUpPersonSign = pickUpPersonSignPicId; // 保存用id
      this.pickUpPersonSignPath = pickUpPersonSignPath;
      localStorage.removeItem('pickUpPersonSignPath');
      localStorage.removeItem('pickUpPersonSignPicId');
    }
    if (this.dataForm.customerSign || this.dataForm.operatorSign || this.dataForm.pickUpPersonSign) {
      this.confirm();
    }
  },
  methods: {
    async setCarStatus(carStatus) {
      this.dataForm.carStatus = carStatus || '';
    },
    async saveCarStatus() {
      try {
        await saveRescueReport({
          taskNo: this.taskNo,
          ...this.dataForm
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          this.formData = data;
          const extraProduct = this.taskDetail.extraProduct || [];
          const extraProductStringList = extraProduct.map(item => `${item.name}(${Number(item.value)})`) || [];
          this.formData.extraProductInfo = this.$route.query.extraProduct || extraProductStringList.join(',');
          this.formData.arriveMileageInfo = data.arriveMileage || data.startEstimateDistance || 0;
          this.formData.appealDistanceInfo = data.appealDistance || data.orderMileage || 0;
          this.formData.createTime = this.formData.orderCreateTime ? dayjs(this.formData.orderCreateTime).format('YYYY-MM-DD') : '';

          // 判断华安拖车订单
          if (this.isHAIC && this.isTrailer && !this.dataForm.carStatus && this.taskDetail.blackScreen === 1) {
            this.setCarStatus('故障状态无法复现，确需拖车服务');
            this.saveCarStatus();
          }
        }
        if (!noLoading) {
          this.$toast.clear();
        }
        try {
          const res = await jsApi.hiddenCancelByStatus({ taskStatus: this.taskDetail.taskStatus, appServiceType: this.taskDetail.appServiceType, orderNo: this.taskDetail.orderNo, taskNo: this.taskDetail.taskNo });
          if (res) {
            console.log(res);
          }
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRescueReport() {
      try {
        const data = await getRescueReport({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          // this.dataForm = data;
          this.dataForm.rescueEnvironment = data.rescueEnvironment || [];
          this.customerSignPath = data.customerSign || '';
          this.operatorSignPath = data.operatorSign || '';
          this.pickUpPersonSignPath = data.pickUpPersonSign || '';
          this.dataForm.customerSign = data.customerSignImgId || '';
          this.dataForm.operatorSign = data.operatorSignImgId || '';
          this.dataForm.pickUpPersonSign = data.pickUpPersonSignImgId || '';
          this.dataForm.carStatus = data.carStatus || '';
        }
        this.getTaskDetail();
      } catch (error) {
        console.log(error);
      }
    },
    goCustomerSign() {
      if (this.isTPBX) {
        const that = this;
        that.$refs.confirmDialog.open({
          confirmText: '请签署全名',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmCallback: () => {
            that.$nextTick(() => {
              that.goCustomerSignPage();
            });
          }
        });
      } else {
        this.goCustomerSignPage();
      }
    },
    goCustomerSignPage() {
      this.$emit('clickHandler');
      this.$router.push({
        path: '/generalOrder/sign',
        query: {
          type: 'customerSign'
        }
      });
    },
    goOperatorSign() {
      this.$emit('clickHandler');
      this.$router.push({
        path: '/generalOrder/sign',
        query: {
          type: 'operatorSign'
        }
      });
    },
    goPickUpPersonSign() {
      this.$emit('clickHandler');
      this.$router.push({
        path: '/generalOrder/sign',
        query: {
          type: 'pickUpPersonSign'
        }
      });
    },
    cancel() {
      if (this.isH5) {
        this.$router.go(-1);
      } else {
        jsApi.closeCurrentWebView();
      }
      localStorage.setItem('isSign', 0);
    },
    async confirm(noLoading) {
      // if (this.taskDetail.rescueResult === 1 && !this.dataForm.customerSign) {
      //   this.$toast('请先完善电子工单');
      //   return;
      // }
      // if (!this.dataForm.operatorSign) {
      //   this.$toast('请先完善电子工单');
      //   return;
      // }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await saveRescueReport({
          taskNo: this.taskNo,
          ...this.dataForm
        });
        this.$toast('保存成功');
        if (!noLoading) {
          this.$toast.clear();
        }
        localStorage.setItem('isSign', '0');
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.workOrders{
  .signContent{
    .signCard{
      margin-top: 12px;
      padding: 16px;

      border-radius: 8px;
      background: #FFFFFF;

      .signTitle{
        padding-bottom: 16px;

        letter-spacing: -0.41px;

        color: #F32222;

        font-family: PingFangSC-Medium;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
      }

      .textarea-box,
      ::v-deep .textarea-box{
        padding: 12px;

        letter-spacing: -0.38px;

        border: 1px solid rgba(200,200,200,1);
        border-radius: 8px;
        background: #FFFFFF;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        ::v-deep .van-field__control{
          color: #383838;

          &::placeholder{
            color: #C8C8C8;
          }
        }
      }
    }
    .signature__pad {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 50px;

      letter-spacing: -0.41px;

      color: #9AAFC4;
      border: 1px dashed rgba(178,202,227,1);
      border-radius: 8px;
      background: #EFF3F6;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;

      .signIcon{
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
    }

    .signature__img {
      width: 100%;
      height: 80px;

      border: 1px dashed rgba(178,202,227,1);
      border-radius: 8px;
    }
  }
}
</style>
